import { shareMedicalHistory } from 'store/medicalHistory/actions';
import { shareAllergies } from 'store/medicalHistory/allergies/actions';
import { shareClinicNoteDocument } from 'store/clinicNotes/actions';
import {
  shareImmunizations,
  shareWithExternalUtahSchoolImmunizationRecord
} from 'store/medicalHistory/immunizations/actions';
import { shareProblems } from 'store/medicalHistory/problems/actions';
import { shareProcedures } from 'store/medicalHistory/procedures/actions';
import { shareSocialHistory } from 'store/medicalHistory/socialHistory/actions';
import { shareMedicationDetail, shareMedications } from 'store/medications/actions';
import { shareImagingResults } from 'store/testResults/imaging/actions';
import { shareLabResults } from 'store/testResults/lab/actions';
import { shareMicrobiologyResults } from 'store/testResults/microbiology/actions';
import { sharePathologyResults } from 'store/testResults/pathology/actions';
import { shareVisitSummaryCcd, shareMultipleVisitSummaryCcd } from 'store/visitSummary/actions';
import { shareVitals } from 'store/vitals/actions';
import { shareAppointment } from 'store/booking/actions';
import { shareBillingDetail, sharePaymentDetail } from 'store/billing/actions';
import { shareHealthRecordSummary } from './healthRecords/actions';

export enum TransmitSources {
  Appointments = 'Appointments',
  BillingDetail = 'BillingDetail',
  ClinicNotes = 'ClinicNotes',
  VisitSummary = 'VisitSummary',
  MedicationDetails = 'MedicationDetails',
  Medications = 'Medications',
  Vitals = 'Vitals',
  Allergies = 'Allergies',
  Immunizations = 'Immunizations',
  Problems = 'Problems',
  Procedures = 'Procedures',
  SocialHistory = 'SocialHistory',
  MedicalHistory = 'MedicalHistory',
  LabResults = 'LabResults',
  MicrobiologyResults = 'MicrobiologyResults',
  ImagingResults = 'ImagingResults',
  PathologyResults = 'PathologyResults',
  PaymentDetail = 'PaymentDetail',
  UtahSchoolImmunizationRecord = 'UtahSchoolImmunizationRecord',
  HealthRecordSummary = 'HealthRecordSummary'
}

export const getTransmitAction = (source: TransmitSources) => {
  return {
    Appointments: shareAppointment,
    BillingDetail: shareBillingDetail,
    ClinicNotes: shareClinicNoteDocument,
    VisitSummary: shareVisitSummaryCcd,
    MultipleVisitSummary: shareMultipleVisitSummaryCcd,
    Medications: shareMedications,
    MedicationDetails: shareMedicationDetail,
    Vitals: shareVitals,
    Allergies: shareAllergies,
    Immunizations: shareImmunizations,
    Problems: shareProblems,
    Procedures: shareProcedures,
    SocialHistory: shareSocialHistory,
    MedicalHistory: shareMedicalHistory,
    HealthRecordSummary: shareHealthRecordSummary,
    LabResults: shareLabResults,
    MicrobiologyResults: shareMicrobiologyResults,
    ImagingResults: shareImagingResults,
    PathologyResults: sharePathologyResults,
    PaymentDetail: sharePaymentDetail,
    UtahSchoolImmunizationRecord: shareWithExternalUtahSchoolImmunizationRecord
  }[source];
};
